/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import NewTable from '../../components/NewTable/NewTable';
import { userActions } from '../../_actions/user.actions';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../components/Pagination/Pagination';
import moment from 'moment';
import { alertActions, coinManagementActions } from '../../_actions';
import Loader from '../../components/Atoms/Loader';
import { FaRegEye } from 'react-icons/fa';
import ViewHistory from '../AddFundExpressHistory/Components/ViewHistory';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import { IoMdCheckmarkCircleOutline } from 'react-icons/io';

import ActionPopup from '../../components/Atoms/ActionPopup/ActionPopup';
const size = 10
const SwapHistory = () => {
  const dispatch = useDispatch()
  const selector = useSelector(state => state)
  const [swap, setSwap] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('ALL');
  const [pageNo, setPageNo] = useState(1)
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState('')
  const [count, setCount] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [error, setError] = useState('');



  useEffect(() => {
    function getCountList() {
      coinManagementActions.getAmountAndCount({ type: "SWAP_HISTORY" }).then((res) => {
        if (res) {
          setCount(res?.data)
        }
      }).catch((err) => console.log(err))
    }
    getCountList()
  }, []);





  const sortingOptions = [
    { value: 'ALL', label: 'Sort by All' },
    { value: 'pending', label: 'Sort by Pending' },
    { value: 'completed', label: 'Sort by Completed' },
    { value: 'failed', label: 'Sort by Failed' },
    { value: 'rejected', label: 'Sort by Rejected' },
  ];

  const details =
  {
    keyWord: searchTerm,
    pageNo: pageNo,
    size: size,
    fromDate: fromDate,
    toDate: toDate,
    status: sortBy
  }
  useEffect(() => {
    dispatch(userActions?.getSwappingList(details))
  }, [pageNo, searchTerm, size, sortBy, fromDate, toDate])

  useEffect(() => {
    setSwap(selector?.users?.swappingList?.list)
  }, [pageNo, selector, fromDate, toDate, dispatch]);

  const statusStyles = {
    pending: 'bg-[#FFA600]',
    completed: 'bg-[#02BC7D]',
    failed: 'bg-[#F6465D]',
    rejected: 'bg-[#F6465D]'
  };
  const tableHeadings = ['User', 'Swap Type', 'Swap Amount', 'Amount', 'Status', 'Date', 'Action']
  const tableRows = swap?.map((ele, index) => [
    <div>
      <p>{ele?.userId?.name || "N/A"}</p>
      <p>{ele?.userId?.email || "N/A"}</p>
    </div>,
    ele?.swapType ?? "N/A",
    (ele?.swapAmount ?? 0).toFixed(4) ?? "N/A",
    ele?.amount ?? "N/A",
    <div className='flex items-center capitalize'>
      <div className={`w-1 h-4 mr-2 rounded-md ${statusStyles[ele?.status] || 'bg-gray-500'}`}></div>
      {ele?.status}
    </div>,
    <span className=''>
      {moment(ele?.createdAt).format("MMMM Do YYYY, h:mm:ss a")}
    </span>,
    <div className='flex justify-start items-center flex-wrap gap-2'>
      <span onClick={() => handleSwapDetails(ele)}>
        <FaRegEye className="text-[22px] text-blue-500" title='View' />
      </span>
      {
        ele?.status === "pending" && (
          <>
            <div className="flex items-center justify-center w-5 h-5">
              <button className='cursor-pointer' onClick={() => handleStatusChange("rejected", ele._id)}>
                <AiOutlineCloseCircle className="text-[22px] text-[#F6465D]" title='Reject' />
              </button>
            </div>
            <div className="flex items-center justify-center w-5 h-5">
              <button onClick={() => handleStatusChange("approved", ele._id)}>
                <IoMdCheckmarkCircleOutline className="text-[22px] text-[#02BC7D]" title='Approve' />
              </button>
            </div>
          </>
        )
      }

    </div>

  ])

  const summaryDataFull = {
    sent: { amount: (count[0]?.totalAmount ?? 0).toFixed(4), fees: (count[0]?.totalFee ?? 0).toFixed(4) },
    received: { amount: (count[1]?.totalAmount ?? 0).toFixed(4), fees: (count[1]?.totalFee ?? 0).toFixed(4) }
  };

  const handleSortByStatus = (e) => {
    const selectedSort = e.target.value;
    setSortBy(selectedSort);
  };

  const onPageChange = page => {
    setPageNo(page)
  }

  const handleDateRangeChange = (start, end) => {
    setFromDate(start)
    setToDate(end)
  }

  const handleSwapDetails = (data) => {
    setIsLoading(true)
    userActions.getSwappingDetails({ id: data?._id }).then((res) => {
      if (res?.data) {
        setData(res?.data)
      }
    }).catch((error) => {
      dispatch(alertActions.error(error || "An error accrue to fetch data"))
    }).finally(() => {
      setIsLoading(false)
      setIsModalOpen(true)

    })
  }

  const toggleModal = () => {
    setIsModalOpen(false)
    setData(null)
  }

  const [showActionPopup, setShowActionPopup] = useState(false);
  const [selectedData, setSelectedData] = useState({
    status: "",
    kycId: "", failureReason: ""
  });

  const handleStatusChange = (status, kycId) => {
    const reqData = { status, kycId }
    if (status !== "approved") {
      reqData.notes = ""
    }
    setSelectedData(reqData);
    setShowActionPopup(true);
  };


  const handleClose = () => {
    setShowActionPopup(false)
    setSelectedData({
      status: "",
      kycId: "", failureReason: ""
    })
    setError({})
  }


  const handleConfirm = () => {
    let errors = {};
    if ((selectedData?.status === "rejected" || selectedData?.status === "more-info") && !selectedData?.failureReason?.trim()) {
      errors.inputValue = "Please provide a reason.";
    }
    if (Object.keys(errors).length > 0) {
      setError(errors);
      return;
    }

    const statusToSend =
      selectedData?.status === "approved" ? "completed" : selectedData?.status;
    const payload = {
      swapId: selectedData?.kycId,
      failureReason: selectedData?.failureReason,
      status: statusToSend
    }
    setIsLoading(true)
    userActions.updateSwapStatus(payload)
      .then((response) => {
        dispatch(alertActions.success(response?.message || ""))
      })
      .catch((err) => {
        dispatch(alertActions.error(err));
      }).finally(() => {
        setIsLoading(false)
        dispatch(userActions?.getSwappingList(details))
      })

    setShowActionPopup(false);
  };

  return (
    <div className='p-4'>
      <Loader loading={selector?.users?.loading || isLoading} />
      <NewTable
        Heading="Swap History"
        walletId="30,090"
        tableHeadings={tableHeadings}
        data={tableRows}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
        showSearch={false}
        placeholder="Search by name, email, phone or ID..."
        summaryDataFull={summaryDataFull}
        showSorting={true}
        onSortByStatus={handleSortByStatus}
        sortStatusValue={sortBy}
        sortingOptions={sortingOptions}
        fromDate={fromDate}
        setFromDate={setFromDate}
        setToDate={setToDate}
        toDate={toDate}
        showDropDown1={true}
        showDateFilter={true}
        handleDateRangeChange={handleDateRangeChange}
        showPageTopData1={true}
        showPageTopData2={true}
      />

      {Math.ceil(selector?.users?.swappingList?.total / size) >
        1 && (
          <Pagination
            totalPages={Math.ceil(
              selector?.users?.swappingList?.total / size
            )}
            currentPage={pageNo}
            onPageChange={onPageChange}
            total={Math.ceil(selector?.users?.swappingList?.total)}
          />
        )}

      <ViewHistory isOpen={isModalOpen} data={data} onClose={toggleModal} heading={`Swap History`} />
      <ActionPopup
        inputValue={selectedData?.failureReason ?? ""}
        handleInputValue={(value) =>
          setSelectedData((prev) => ({
            ...prev,
            failureReason: value
          }))
        }
        handleConfirm={handleConfirm}
        onClose={handleClose}
        showActionPopup={showActionPopup}
        heading={`Are you sure you want to ${selectedData?.status}?`}
        showInput={false} // input is no longer used
        inputPlaceholder="Enter rejection reason..."
        imageUrl="/warning.png"
        // statusHeading={selectedData?.status}
        inputError={error}
        isNote={selectedData?.status === "rejected" || selectedData?.status === "more-info"}
        noteValue={selectedData?.failureReason}
        noteChange={(value) => {
          setSelectedData((prev) => ({ ...prev, failureReason: value }));
          setError("");
        }}

      />
    </div>
  );
};

export default SwapHistory